// extracted by mini-css-extract-plugin
export default {"MetricsTitle":"iStyles_MetricsTitle__g88Ca"};